<script>
    import { _updatePassword } from "../../firebase/auth";
    import { navigate } from "svelte-routing";
    import CurrentPassword from "../../components/passwords/CurrentPassword.svelte";
    import NewPassword from "../../components/passwords/NewPassword.svelte";
    import PasswordRequirements from "../../components/passwords/PasswordRequirements.svelte";
    import AuthError from "../../components/auth/AuthError.svelte";
    import Input from "../../components/Input.svelte";
    import Button from "../../components/Button.svelte";
    import ButtonPrimary from "../../components/ButtonPrimary.svelte";
import PasswordRecoveryLink from "../../components/passwords/PasswordRecoveryLink.svelte";
    
    let currentPassword;
    let newPassword;
    let errorCode;

    async function updatePassword () {
        errorCode = undefined;
        _updatePassword(currentPassword, newPassword)
        .then(() => {
            currentPassword = undefined;
            newPassword = undefined;
            alert("Passwort erfolgreich geändert.");
            navigate("/account");
        })
        .catch((error) => {
            errorCode = error.code;
        })
    }
</script>

<div class="form">
    <h1>Passwort ändern</h1>
    <form on:submit|preventDefault={updatePassword}>
        <Input type=password bind:value={currentPassword} label="Aktuelles Passwort"/>
        <Input type=password bind:value={newPassword} label="Neues Passwort" autocomplete="new-password"/>
        <PasswordRequirements bind:password={newPassword}/>
        <div class="actions">
            <ButtonPrimary type="submit" disabled={!newPassword || !currentPassword}>Passwort ändern</ButtonPrimary>
            <PasswordRecoveryLink />
        </div>
    </form>
    <AuthError errorCode={errorCode}/>
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }
    
    .actions {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
    }
</style>